import * as React from "react";

interface ICollapseProps {
    isOpen: boolean;
}

interface ICollapseState {
    height: string;
    collapseState: "SHOW" | "SHOWN" | "HIDE" | "HIDDEN";
}

class Collapse extends React.Component<ICollapseProps, ICollapseState> {
    public static getDerivedStateFromProps(nextProps: ICollapseProps, prevState: ICollapseState) {

        if (nextProps.isOpen) {
            prevState.collapseState = "SHOW";
        } else {
            prevState.collapseState = "HIDE";
            prevState.height = "";
        }

        return prevState;
    }

    private element: HTMLDivElement | null;
    private timer: NodeJS.Timer;

    constructor(props: ICollapseProps) {
        super(props);

        this.state = { height: "", collapseState: props.isOpen ? "SHOW" : "HIDE" };

        this.getCollapseClass = this.getCollapseClass.bind(this);
        this.transition = this.transition.bind(this);
    }

    public componentDidUpdate(prevProps: ICollapseProps, prevState: ICollapseState) {
        if (this.props.isOpen === prevProps.isOpen) { return; }
        if (!this.element) { return; }

        if (this.timer) {
            clearTimeout(this.timer);
        }

        if (this.props.isOpen) {
            this.setState({ height: `${this.element.scrollHeight}px` })
        }

        this.timer = setTimeout(this.transition, 350);
    }

    public componentWillUnmount() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
    }

    public render() {
        return (
            <div ref={ref => this.element = ref} className={this.getCollapseClass()} style={{ height: this.state.height }}>
                {this.props.children}
            </div>
        );
    }

    private transition() {
        if (!this.element) { return; }

        let nextState = this.state.collapseState;
        let nextHeight = this.state.height;

        switch (this.state.collapseState) {
            case "SHOW":
                nextState = "SHOWN";
                nextHeight = `${this.element.scrollHeight}px`;
                break;
            case "HIDE":
                nextState = "HIDDEN";
                nextHeight = "";
                break;
        }

        this.setState({ collapseState: nextState, height: nextHeight });
    }

    private getCollapseClass(): string {

        switch (this.state.collapseState) {
            case "SHOW":
                return "collapsing";
            case "SHOWN":
                return "collapse show";
            case "HIDE":
                return "collapsing";
            case "HIDDEN":
                return "collapse";
        }

        return "collapse";
    }
}

export default Collapse;



// WEBPACK FOOTER //
// ./src/core/Collapse/Collapse.tsx